import { variant } from 'styled-system'
import styled, { css } from 'styled-components'
import { ToastProps } from './Toast.types'
import Flex from '../Flex'

const placementVariant = variant({
  prop: 'placement',
  variants: {
    bottom: {
      justifyContent: 'center',
      left: '0',
      right: '0',
      bottom: '24px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    'bottom-left': {
      left: '24px',
      bottom: '24px',
    },
    'bottom-right': {
      right: '24px',
      bottom: '24px',
    },
    top: {
      justifyContent: 'center',
      left: '0',
      right: '0',
      top: '24px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    'top-left': {
      left: '24px',
      top: '24px',
    },
    'top-right': {
      right: '24px',
      top: '24px',
    },
  },
})

const styling = css`
  justify-content: center;
  position: fixed;
  align-items: center;
  text-align: center;
  gap: 16px;
  flex-direction: column;
  width: fit-content;
`
const StyledFlexWrapper = styled(Flex)<ToastProps>`
  ${placementVariant}
  ${styling}
`

const stylingToast = css`
  visibility: visible;
  -webkit-animation: fadein 0.5s;
  animation: fadein 0.5s;

  @-webkit-keyframes fadein {
    from {
      bottom: -30px;
      opacity: 0;
    }
    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes fadein {
    from {
      bottom: -30px;
      opacity: 0;
    }
    to {
      bottom: 0px;
      opacity: 1;
    }
  }
`

const StyledFlexToast = styled(Flex)`
  ${stylingToast}
`

export { StyledFlexWrapper, StyledFlexToast }
